import axios from '../../axios'

export default {
  getFiltered: function (regionIds, departmentIds, complexIds) {
    return axios.post('assets/filtered', {
      'regionIds': regionIds,
      'departmentIds': departmentIds,
      'complexIds': complexIds
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/AssetsApi.js